import promiseClient from 'hub-http/adapters/promiseClient';
import hubHttpClient from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { chatSpotV1ApiStack, chatSpotV1HighVolumeStack, chatSpotV1Stack, chatSpotV1StreamingStack } from './internal/stacks';
import sseClient from './sse/sseClient';
export const ChatSpotV1Client = promiseClient(chatSpotV1ApiStack);
export const ChatSpotV1StreamingClient = sseClient(chatSpotV1StreamingStack);
export const ChatSpotV1ClientApi = promiseClient(chatSpotV1Stack);
export const ChatSpotV1HighVolumeApi = promiseClient(chatSpotV1HighVolumeStack);
export const rpcClient = createRpcClientV2({
  hubHttpClient
});